export const ALLOWED_ID_IMAGE_ACCEPT = {
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"],
  "image/gif": [".gif"],
  "image/webp": [".webp"],
  "image/heic": [".heic"],
  "image/heif": [".heif"],
  "image/bmp": [".bmp"],
  "image/tiff": [".tif", ".tiff"],
  "image/avif": [".avif"],
  "image/svg+xml": [".svg"],
  "image/x-icon": [".ico", ".cur"],
  "image/vnd.microsoft.icon": [".ico"],
};

const ALLOWED_ID_IMAGE_MIMES = new Set(Object.keys(ALLOWED_ID_IMAGE_ACCEPT));
const ALLOWED_ID_IMAGE_EXTENSIONS = new Set(
  Object.values(ALLOWED_ID_IMAGE_ACCEPT)
    .flat()
    .map((ext) => ext.slice(1))
);

const GENERIC_FILE_MIMES = new Set(["", "application/octet-stream", "binary/octet-stream"]);

export const ID_IMAGE_ONLY_MESSAGE = "Please upload your ID as an image file.";

export function isAllowedIdImageFile(file) {
  if (!file) return false;
  const mime = String(file.type).split(";")[0].trim().toLowerCase();
  if (ALLOWED_ID_IMAGE_MIMES.has(mime)) return true;

  const ext = String(file.name).split(".").pop().trim().toLowerCase();

  return GENERIC_FILE_MIMES.has(mime) && ALLOWED_ID_IMAGE_EXTENSIONS.has(ext);
}
